/* eslint-disable prefer-destructuring */
import React from 'react';
import * as RC from '@beef/redux-current';
import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_RISK_BECOMING_MAINTAINER } from '@beef/redux-current/internal';

/**
 * @deprecated use import { CurrentProvider } from '@beef/redux-current'
 * NOTE: `values` is now `bulk`
 */
export var CurrentBulkProvider = function CurrentBulkProvider(_ref) {
  var values = _ref.values,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(RC.CurrentProvider, {
    bulk: values
  }, children);
};
/** @deprecated use import { CurrentProvider } from '@beef/redux-current' */
export var CurrentKeyProvider = RC.CurrentProvider;
/** @deprecated use import { CurrentProvider } from '@beef/redux-current' */
export var ProvideCurrent = RC.CurrentProvider;
/** @deprecated use import { CurrentProvider } from '@beef/redux-current' */
export var ProvideCurrentKey = RC.CurrentProvider;
/**
 * @deprecated internal api, do not use, unless you must, then
 * import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_RISK_BECOMING_MAINTAINER } from '@beef/redux-current/internals'
 */
export var selectCurrents = __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_RISK_BECOMING_MAINTAINER.selectCurrents;

/**
 * @deprecated use import { createInjectableSelector } from '@beef/redux-current'
 * NOTE: `KEY` is now second argument
 */
export var createInjectableSelector = function createInjectableSelector(KEY) {
  return RC.createInjectableSelector(undefined, KEY);
};

/** @deprecated use import { createInjectableAction } from '@beef/redux-current' */
export var createInjectableCallback = function createInjectableCallback(KEY) {
  return RC.createInjectableAction(KEY);
};

/** @deprecated use import { composeCurrentKeySelector } from '@beef/redux-current' */
export var composeCurrentKeySelector = RC.composeCurrentKeySelector;

/** @deprecated use import { createCurrentModule } from '@beef/redux-current' */
// @ts-expect-error legacy typing are hard to fix
export var createCurrentModule = RC.createCurrentModule;